import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { Box } from '@mui/material';

export default function AppPreview(props: any) {
  const googleAnalyticsUrl = "https://analytics.google.com/analytics/web/?authuser=1#/p237280658/reports/intelligenthome";
  return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.open}
        onClick={props.handleClose}
      >
        <Box bgcolor="white" border="7px black solid" borderRadius="20px" height="84.4%" width="24.5%" ><iframe title="googleAnalytics" style={{ borderRadius: "19px" }} src={googleAnalyticsUrl} height="100%"  width="100%"/></Box>
      </Backdrop>
  );
}